// Auth
export const LOGIN = 'LOGIN'
export const SET_USER = 'SET_USER'
export const LOGOUT = 'LOGOUT'

// Params
export const SET_PARAMS = 'SET_PARAMS'

// Order
export const CHANGE_TABLE = 'CHANGE_TABLE'
export const CHANGE_ORDER_TYPE = 'CHANGE_ORDER_TYPE'

export const ADD_ORDER_ITEM = 'ADD_ORDER_ITEM'
export const MODIFY_ORDER_ITEM = 'MODIFY_ORDER_ITEM'
export const REMOVE_ORDER_ITEM = 'REMOVE_ORDER_ITEM'
export const CLEAR_ORDER = 'CLEAR_ORDER'

// Accounting
export const ADD_ACC_ITEM = 'ADD_ACC_ITEM'
export const MODIFY_ACC_ITEM = 'MODIFY_ACC_ITEM'
export const REMOVE_ACC_ITEM = 'REMOVE_ACC_ITEM'
export const CLEAR_ACC_QUEUE = 'CLEAR_ACC_QUEUE'

// Shifts
export const SET_SHIFT = 'SET_SHIFT'

// Code Blue
export const CODE_BLUE = 'CODE_BLUE'
export const INVENTORY_ALERT = 'INVENTORY_ALERT'
